import { useQuery } from "@apollo/client";
import Role from "enums/Role";
import { useCheckUserRole } from "hooks/useCheckUserRole";
import { GET_PLATFORM_REWARDS_AVAILABLE } from "graphql/platform";

/** Whether the platform runs rewards: one of its card programs has them turned on. */
export const usePlatformRewardsAvailable = (): boolean => {
  const isPlatformRoles = useCheckUserRole(Role.PlatformAdmin);
  const { data } = useQuery<{ platformRewardsAvailable: boolean }>(
    GET_PLATFORM_REWARDS_AVAILABLE,
    { skip: !isPlatformRoles },
  );

  return isPlatformRoles && Boolean(data?.platformRewardsAvailable);
};

export default usePlatformRewardsAvailable;
